import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import FormInput from '../../../../components/Form/FormInput';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import { confirmDialog } from 'primereact/confirmdialog';
import MainImageForm from '../../common/image/MainImageForm';

function NewsPanel({
  isOpen,
  onClose,
  news,
  loading,
  onUpdate,
  onCreate,
  handleDeleteNews,
  section
}) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(undefined);

  useEffect(() => {
    if (news) {
      setTitle(news.title);
      setContent(news.content);
      setImage(news.image);
    } else {
      setTitle('');
      setContent('');
      setImage(undefined);
    }
  }, [news, isOpen]);

  const confirmNewsDeletion = (news) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cet article ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteNews(news)
    });
  };

  const onValidate = () => {
    const newsPayload = {
      title,
      content,
      image: image.id,
      type: section,
      scope: 4
    };

    news ? onUpdate(newsPayload) : onCreate(newsPayload);
  };

  const formIsValid = title.length > 3 && content.length > 3 && image;

  const footerButtons = (
    <div className="manage-footer">
      <div className="double-button">
        <Button
          key={'validate'}
          label={`Valider l'article`}
          loading={loading}
          disabled={!formIsValid}
          onClick={() => onValidate(news)}
          severity="success"
          className="w-1/2"
        />
        {news && (
          <Button
            key={'delete'}
            label={`Supprimer l'article`}
            loading={loading}
            outlined
            onClick={() => confirmNewsDeletion(news)}
            severity="danger"
            className="w-1/2"
          />
        )}
      </div>
    </div>
  );

  return (
    <Sidebar
      style={{ width: 900 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${news ? 'Modifier' : 'Ajouter'} un article`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput label={"Titre de l'article"} required isValid={title.length > 3}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre du programme"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <FormInput label={'Contenu'} required isValid={content.length > 3}>
            <RichTextEditor
              value={content}
              onChange={(value) => {
                setContent(value);
              }}
            />
          </FormInput>
          <MainImageForm mainImage={image} setMainImage={setImage} />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default NewsPanel;
